"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 14 11"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.63,11H7A.58.58,0,0,1,7,9.84H9.63A3,3,0,0,0,12.83,7a3,3,0,0,0-3.2-2.9H2L3.91,6a.57.57,0,0,1,0,.82.59.59,0,0,1-.82,0L.17,3.88a.58.58,0,0,1,0-.82L3.09.17a.57.57,0,0,1,.82,0,.57.57,0,0,1,0,.82L2,2.89H9.63A4.13,4.13,0,0,1,14,7,4.13,4.13,0,0,1,9.63,11Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;